// New Multi-Currency Canvas Page Translations - English
export default {
  // Dialog titles
  dialogs: {
    note: "Note",
    batchNote: "Batch Note",
    separateNote: "Separate Note",
    unifiedNote: "Unified Note",
    addLabel: "Add Label",
    editLabel: "Edit Label",
    deleteLabel: "Delete Label",
    addMonitor: "Add Monitor",
    saveInfo: "Save Info",
    modifyInfo: "Modify Info",
  },

  // Form labels
  forms: {
    label: "Label",
    notePlaceholder: "Please enter note content",
    selectPlaceholder: "Please select",
    inputPlaceholder: "Please enter content",
  },

  // Success messages
  success: {
    monitorAdded: "Address monitor added successfully",
    caseDataAdded: "Address added to data dashboard successfully",
    caseDataAnalyzing: "Case data is being analyzed, please wait patiently",
    verifyResultReady: "Verification result is ready",
  },

  // Button text
  buttons: {
    cancel: "Cancel",
    confirm: "Confirm",
    closeDialog: "Close Dialog",
    viewMonitor: "View Monitor",
    viewCaseData: "View Case Data",
    viewVerifyResult: "View Verification Result",
    addNew: "Add New",
  },

  // Loading state
  loading: {
    text: "Loading...",
  },

  // Left menu
  leftMenu: {
    details: "Details",
    filter: "Filter",
    survey: "Survey",
    history: "History",
    canvasFilter: "Canvas Filter",
  },

  // Tooltip messages
  tooltip: {
    unsavedCanvas:
      "Please save and associate the case first (unsaved canvases cannot be auto-saved); complete this to unlock more in-depth analysis capabilities.",
  },

  // Notification messages
  notifications: {
    tooManyNodes: {
      title: "Notice",
      message:
        "Too many nodes on the canvas may affect canvas performance. It is recommended to create a new canvas",
    },
    aggregateEdgeWarning: {
      title: "Warning",
      message: "Aggregate edge operations do not support expansion",
    },
    aggregateNodeWarning: {
      title: "Notice",
      message: "Aggregate nodes do not support this operation!",
    },
  },
};
